import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'mt-h4',
    templateUrl: './h4.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class H4Component implements OnInit {
  constructor() {}

  ngOnInit() {}
}
